// extracted by mini-css-extract-plugin
export default {"container":"Learning_container__703Xe","text":"Learning_text__WY+nf","button":"Learning_button__UEe0H"};